<template>
  <ul
    :class="[type !== null ? `list--${type}` : null]"
  >
    <li
      v-for="(slot, index) in slots"
      :key="slot"
    >
      <template v-if="(type === 'project' || type === 'team') && index === 0">
        <div
          class="list__line list__line--first"
          data-anim="line"
          data-view="false"
        />
      </template>

      <template v-if="dots">
        <div class="list__dot">
          <div class="list__dot__line" data-anim="line" data-view="false" />
          <div class="list__dot__circle" data-anim="fade" data-view="false" />
        </div>
      </template>
      <slot :name="slot" />

      <template v-if="(type === 'project' || type === 'team')">
        <div
          class="list__line"
          data-anim="line"
          data-view="false"
        >
          <div
            class="list__line--hover"
            style="transform: scaleX(0)"
          />
        </div>

        <div
          class="discover"
          style="transform: translate3d(0, 100%, 0); opacity: 0;"
        >
          Discover more
        </div>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'List',

  props: {
    slots: {
      type: Array,
      required: true,
    },

    dots: {
      type: Boolean,
      required: false,
      default: false,
    },

    type: {
      type: String,
      required: false,
    }
  },
};
</script>

<style lang="scss" scoped>
ul {
  padding: rem(40px) 0;

  @include mq(ipadP) {
    padding: rem(80px) 0;
  }

  li {
    position: relative;

    &:not(:last-child) {
      margin-bottom: rem(80px);
    }
  }

  &.list--project {
    padding: rem(80px) 0 0 0;

    @include mq(ipadP) {
      padding: rem(100px) 0 0 0;
    }

    li {
      padding: rem(68px) 0;

      @include mq(ipadP) {
        padding: rem(86px) 0;
      }
      margin-bottom: 0;

      a {
        display: block;
        
        * {
          pointer-events: none;
        }
      }
    }
  }

  &.list--team {
    padding: rem(80px) 0 0 0;

    @include mq(ipadP) {
      padding: rem(100px) 0 0 0;
    }

    li {
      padding: rem(118px) 0 rem(68px);

      @include mq(ipadP) {
        padding: rem(136px) 0 rem(86px);
      }
      margin-bottom: 0;

      a {
        display: block;

        * {
          pointer-events: none;
        }
      }
    }
  }

  .list__line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;

    background-color: rgba($color-dark-light, 0.3);

    &--first {
      top: 0;
      bottom: auto;
    }

    &--hover {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;

      background-color: rgba($color-text, 0.5);
      transform-origin: 0 0;
    }
  }

  .list__dot {
    position: absolute;
    top: 0;
    left: 0;
    height: rem(65px);

    &__circle {
      position: absolute;
      top: 50%;
      left: -64px;
      width: 14px;
      height: 14px;
      margin-top: -7px;
      border-radius: 50%;

      border: 1px $color-dark-light solid;
    }

    &__line {
      position: absolute;
      bottom: 0;
      left: -100px;
      width: 50px;
      height: 1px;

      background-color: $color-dark-light;
    }
  }
}

.discover {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
